import { render } from "./LicenseTabs.vue?vue&type=template&id=cdbbde6c&scoped=true"
import script from "./LicenseTabs.vue?vue&type=script&lang=js"
export * from "./LicenseTabs.vue?vue&type=script&lang=js"

import "./LicenseTabs.vue?vue&type=style&index=0&id=cdbbde6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbbde6c"]])

export default __exports__